/* tslint:disable */
/* eslint-disable */
/**
 * DAM PORTAL API
 * API for handling DAM PORTAL operations.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LastUpdateResponse
 */
export interface LastUpdateResponse {
    /**
     * 
     * @type {Date}
     * @memberof LastUpdateResponse
     */
    lastUpdate?: Date;
}

export function LastUpdateResponseFromJSON(json: any): LastUpdateResponse {
    return LastUpdateResponseFromJSONTyped(json, false);
}

export function LastUpdateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LastUpdateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lastUpdate': !exists(json, 'lastUpdate') ? undefined : (new Date(json['lastUpdate'])),
    };
}

export function LastUpdateResponseToJSON(value?: LastUpdateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lastUpdate': value.lastUpdate === undefined ? undefined : (value.lastUpdate.toISOString()),
    };
}

